// extracted by mini-css-extract-plugin
export default {"p0Container":"styles-module__p0Container___5GEZE","blackFriday":"styles-module__blackFriday___uPp0O"};